import React, { forwardRef, useState, useEffect } from "react";
import { Column, Row } from "@/shared/ui/Blocks";
import { Button } from "@/shared/ui/Button";

interface SubmitableTextareaProps
  extends Omit<React.HTMLProps<HTMLTextAreaElement>, "onSubmit"> {
  RightContent?: React.ReactNode;
  onSubmit?: (value: string) => void;
  onCancel?: () => void;
}

const SubmitableTextarea = forwardRef<
  HTMLTextAreaElement,
  SubmitableTextareaProps
>((props, ref) => {
  const { RightContent, onSubmit, onCancel, defaultValue, ...rest } = props;
  const [value, setValue] = useState((defaultValue as string) || "");

  useEffect(() => {
    setValue((defaultValue as string) || "");
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const handleCancel = () => {
    setValue("");
    onCancel?.();
  };

  return (
    <Row className="border border-solid border-grey-300 p-2">
      {RightContent}
      <Column className="w-full">
        <textarea
          autoFocus
          {...rest}
          ref={ref}
          value={value}
          onChange={handleChange}
          className="w-full h-32 resize-none p-2 border-transparent outline-none"
        />
        <Row className="items-center justify-end w-full ">
          <Button
            variant="ghost"
            className="text-grey-500"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            variant="ghost"
            className="text-blue-500"
            disabled={!value.trim()}
            onClick={() => onSubmit && onSubmit(value.trim())}
          >
            Save
          </Button>
        </Row>
      </Column>
    </Row>
  );
});

SubmitableTextarea.displayName = "SubmitableTextarea";

export { SubmitableTextarea };
